module.exports = __webpack_public_path__ + "fonts/Roboto-Medium.e624b10d.woff";